import { createBrowserClient } from '@supabase/ssr';
import { createClient as createSupabaseClient } from '@supabase/supabase-js';

const SUPABASE_URL = process.env.NEXT_PUBLIC_SUPABASE_URL!;
const SUPABASE_ANON_KEY = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!;

// Module-level singleton — one browser client for the lifetime of the module.
let browserClient: ReturnType<typeof createBrowserClient> | null = null;

export function createClient() {
  if (typeof window === 'undefined') {
    // Server-side path (hit when 'use client' components are SSR'd).
    // The middleware's createServerClient owns server-side auth via cookies.
    return createSupabaseClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
      global: { headers: { apikey: SUPABASE_ANON_KEY } },
    });
  }

  if (!browserClient) {
    // Use createBrowserClient (from @supabase/ssr) instead of createClient
    // (from @supabase/supabase-js).  The browser client stores the session in
    // cookies — the same storage the middleware's createServerClient uses.
    //
    // When the plain supabase-js client was used, it stored the session in
    // localStorage while the middleware used cookies.  On every navigation the
    // middleware would consume the current refresh token and issue a new one
    // (stored only in the cookie).  The browser client still held the old,
    // now-invalid refresh token in localStorage.  On tab focus, autoRefreshToken
    // tried to use that stale token, Supabase rejected it (refresh-token
    // rotation), and SIGNED_OUT fired — causing all requests to go out as the
    // anonymous role and return 406 errors.
    browserClient = createBrowserClient(SUPABASE_URL, SUPABASE_ANON_KEY);
  }

  return browserClient;
}
